
export class SectionMenuView{
    menuId: number;
    sectionId: number;
    sectionName: string;
    sectionNameEnglish: string;
    processId: number;
    processName: string;
    processNameEnglish: string;
    fieldId: number;
    fieldName: string;
    fieldNameEnglish: string;
    fieldTypeId: number;
    fieldTypeName: string;
}
